import React, { useContext, Fragment, useState, useEffect } from 'react'

import { Buttons } from '../../lib-atomic'
import { GlobalContext } from '../../lib-atomic-context'
import {
  LocalStorage,
  FetchContextApiV2,
  FetchLoggerApi,
} from '../../lib-atomic-functions'

import CheckerPopup from '../../app-popup-section-confirm/default'

import CONFIG from '../config'

const CMSENDPOINTS = CONFIG.application.cms.api.endpoints

const CMSDELETECONTENTCONFIG = {
  url: CMSENDPOINTS.deletecontent.url,
  method: CMSENDPOINTS.deletecontent.method,
  headers: CMSENDPOINTS.deletecontent.headers,
  responseType: 'json',
}

const Index = (props) => {
  const { token, username } = LocalStorage.getLS().strapi
  const { user, item } = props
  const { id, mastercontentsflag } = item

  const { deletecontent, contentdetail } = useContext(GlobalContext)
  const [visiblePopup, setVisiblePopup] = useState(false)
  const [deleteExec, setDeleteExec] = useState(false)

  const deleteContentExecute = async () => {
    const oldData = contentdetail.state.data
    CMSDELETECONTENTCONFIG.headers.Authorization = 'Bearer ' + token
    const [deleteContent] = FetchContextApiV2(CMSDELETECONTENTCONFIG)
    const fetchResult = await deleteContent({ query: '/' + id }, deletecontent)
    props.history.push('/content/list')

    /* -------------- */
    /* start: logger */
    await FetchLoggerApi({
      username,
      api: CMSDELETECONTENTCONFIG,
      page: 'content-delete',
      oldData: oldData,
      newData: null,
    })
    /* end: logger */
    /* -------------- */
  }

  const handleDelete = ({ id }) => {
    setVisiblePopup(!visiblePopup)
  }

  const isDraft =
    !mastercontentsflag ||
    !mastercontentsflag.status ||
    (mastercontentsflag &&
      mastercontentsflag.status &&
      (mastercontentsflag.status === 'draft' ||
        mastercontentsflag.status === 'pending'))
      ? true
      : false

  const items = [
    {
      user: ['mastercreator', 'creator+approver+publisher'],
      action: handleDelete,
      label: 'Delete',
      status: true,
    },
  ]

  const checkItems = ({ status, user }) => {
    return items.filter(
      (item) => item.status === status && item.user.indexOf(user) > -1
    )
  }

  const menus = checkItems({ status: isDraft, user: user[0].user.username })
  const popupData = {
    ...props,
    toggle: visiblePopup,
    setToggle: setVisiblePopup,
    action: deleteContentExecute,
  }
  return (
    <Fragment>
      {menus.map((menu, index) => {
        return (
          <Fragment>
            <Buttons.Normal key={index} onClick={() => menu.action({ id })}>
              {menu.label}
            </Buttons.Normal>
            &nbsp;
          </Fragment>
        )
      })}
      <CheckerPopup {...popupData} />
    </Fragment>
  )
}

export default Index
